import Vue from 'vue'
import Router from 'vue-router'
import DashboardView from '@/dashboard/views/DashboardView.vue'
import BillingListView from '@/billing/views/BillingListView.vue'
import SellerListView from '@/seller/views/SellerListView.vue'
import SubscriberListView from '@/subscriber/views/SubscriberListView.vue'
import SubscriberForgottenListView from '@/subscriber/views/SubscriberForgottenListView.vue'
import SellerBalanceListReportView from './seller/views/SellerBalanceListReportView.vue'
import SellerComissionListReportView from './seller/views/SellerComissionListReportView.vue'
import CrmView from './crm/views/CrmView.vue'
import store from './store'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/principal',
    },
    {
      path: '/principal',
      name: 'DashboardView',
      component: DashboardView,
      beforeEnter(to, from, next) {
        if (store.getters['userAuthenticated'].hasRoleAdmin() || store.getters['userAuthenticated'].hasRoleBiller()) {
          return next()
        }        

        next('/clientes')
      },
    },
    {
      path: '/faturamento',
      name: 'BillingListView',
      component: BillingListView,
      beforeEnter(to, from, next) {
        if (store.getters['userAuthenticated'].hasRoleAdmin() || store.getters['userAuthenticated'].hasRoleBiller()) {
          return next()
        }        

        next('/clientes')
      },
    },
    {
      path: '/clientes',
      name: 'SubscriberListView',
      component: SubscriberListView,
    },
    {
      path: '/clientes/nao-pagantes',
      name: 'SubscriberForgottenListView',
      component: SubscriberForgottenListView,
      beforeEnter(to, from, next) {
        if (store.getters['userAuthenticated'].hasRoleAdmin() || store.getters['userAuthenticated'].hasRoleBiller()) {
          return next()
        }        

        next('/clientes')
      },
    },
    {
      path: '/vendedores',
      name: 'SellerListView',
      component: SellerListView,
    },
    {
      path: '/vendedores/relatorios/saldo-consolidado',
      name: 'SellerBalanceListReportView',
      component: SellerBalanceListReportView,
    },
    {
      path: '/vendedores/relatorios/comissao',
      name: 'SellerComissionListReportView',
      component: SellerComissionListReportView,
    },
    {
      path: '/crm',
      name: 'CrmView',
      component: CrmView,
      beforeEnter(to, from, next) {
        if (store.getters['userAuthenticated'].hasRoleAdmin() || store.getters['userAuthenticated'].hasRoleSupport()) {
          return next()
        }        

        next('/crm')
      },
    },
  ],
});
